import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import APIDataFetchLoader from "../Others/APIDataFetchLoader";
import { AllIndiaCity, UserProfileData } from "../FetchAPI";
import NotifyMessage from "../Others/NotifyMessage";
// import NotifyMessageNoReload from "../Others/NotifyMessageNoReload";

import Select from "react-select";
import NotifyMessageNoReload from "../Others/NotifyMessageNoReload";
import { useAuth } from "../../Store/AuthContext";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";
// const userID = localStorage.getItem("userid");

export default function AskfreeQuestionForm({ RendomTokenfetch, categoryId }) {
  const { userID } = useAuth();

  const navigate = useNavigate();
  const [ProfileuserData] = UserProfileData(RendomTokenfetch);

  const nameRef = useRef(ProfileuserData?.username || "");
  const emailRef = useRef(ProfileuserData?.email || "");
  const numberRef = useRef(ProfileuserData?.number || "");

  const [CityData] = AllIndiaCity(RendomTokenfetch);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [services, setServices] = useState([]);
  const [subServices, setSubServices] = useState([]);
  const [selectedService, setSelectedService] = useState("");
  const [selectedSubService, setSelectedSubService] = useState("");
  const [formData, setFormData] = useState({
    subject: "",
    question: "",
    agree: false,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [apierror, setapierror] = useState({});

  // Form validation
  const validateForm = () => {
    let errors = {};
    if (!selectedService) errors.service = "Service is required";
    if (!selectedSubService) errors.subService = "Sub Service is required";
    if (!selectedCity) errors.city = "City is required";
    if (!formData.subject) errors.subject = "Question is required";
    if (!formData.question) errors.question = "Description is required";
    if (!formData.agree) errors.agree = "You must agree to the terms";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Throttle function to limit how often the search term is updated
  const throttle = (func, limit) => {
    let lastFunc;
    let lastRan;
    return function (...args) {
      if (!lastRan) {
        func.apply(this, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(() => {
          if (Date.now() - lastRan >= limit) {
            func.apply(this, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    };
  };

  // Memoized filtered cities based on the search term
  const filteredCities = useMemo(() => {
    return CityData.filter((city) =>
      city.ctname.toLowerCase().includes(searchTerm.toLowerCase())
    ).slice(0, 100); // Limit to first 100 results
  }, [searchTerm, CityData]);

  // Convert filtered city data to react-select options
  const cityOptions = filteredCities.map((city) => ({
    value: city.ctid,
    label: city.ctname,
  }));

  // Fetch services when category changes
  useEffect(() => {
    if (!categoryId) return;
    setLoading(true);
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("cat_id", categoryId);
    const FetchServiceData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}community_service`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API service:", response.data);
            if (response.data.Status === "1") {
              setServices(response.data.community_service || []);
              setSubServices([]);
            }
            if (response.data.Status === "0") {
              setServices([]);
              setSubServices([]);
            }
          });
      } catch (err) {
        setapierror(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };

    FetchServiceData();
  }, [RendomTokenfetch, categoryId, userID]);

  // Fetch sub-service when service changes
  useEffect(() => {
    if (!selectedService) return;
    setLoading(true);
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("service", selectedService);
    fdata.append("cat_id", categoryId);
    const FetchSubServiceData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}community_subservice`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Subservice:", response.data);
            if (response.data.Status === "1") {
              setSubServices(response.data.community_subservice || []);
            } else {
              setSubServices([]);
            }
          });
      } catch (err) {
        setapierror(err.message);
        // console.error('Error:', err.response ? err.response.data : err.message);
      } finally {
        setLoading(false);
      }
    };

    FetchSubServiceData();
  }, [RendomTokenfetch, selectedService, categoryId, userID]);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });

    setErrors((prev) => ({
      ...prev,
      [name]: "", // Remove error for the changed field
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Check if user is logged in

    if (!validateForm()) return;
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("catid", categoryId);
    fdata.append("serviceid", selectedService);
    fdata.append("subserviceid", selectedSubService);
    fdata.append("cityid", selectedCity);
    fdata.append("subject", formData.subject);
    fdata.append("question", formData.question);

    fdata.append("name", nameRef.current.value);
    fdata.append("email", emailRef.current.value);
    fdata.append("number", numberRef.current.value);

    axios
      .post(`${WebsiteAPIurl}communityquestionadd`, fdata, {
        headers: {
          Authorization: RendomTokenfetch,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        // console.log(response.data);
        if (selectedService) {
          if (response.data.Status === "0") {
            NotifyMessage(response.data.message, "danger", true);
            // NotifyMessageNoReload(response.data.message, "danger", true);
          }
          if (response.data.Status === "1") {
            var quesdata = response.data.QuestionData;
            // console.log(quesdata);
            // NotifyMessage(response.data.message, "success", true);

            NotifyMessageNoReload(response.data.message, "success", true);

            if (response.data.QuestionData) {
              if (quesdata.catserviceslug && quesdata.communityserviceslug) {
                navigate(
                  `/${quesdata.catserviceslug}/${quesdata.communityserviceslug}`
                );
              }
            }
          }
        } else {
          // console.log(response.data);
        }
      });
    // .catch((error) => {
    //   alert(error);
    // });
  };

  if (loading) {
    return <APIDataFetchLoader />;
  }
  if (apierror) {
  }
  return (
    <form className="AskfreeQuestionForm was-validated" onSubmit={handleSubmit}>
      <div className="row">
        <div className="form-group col-lg-6 col-md-12 col-sm-12 mb-3">
          <select
            className="form-control"
            value={selectedService}
            onChange={(e) => setSelectedService(e.target.value)}
            required
          >
            <option value="">Select Service</option>
            {services.map((value, index) => (
              <option value={value.id} key={index}>
                {value.community_service}
              </option>
            ))}
          </select>
          {errors.service && (
            <span className="text-danger">{errors.service}</span>
          )}
        </div>
        <div className="form-group col-lg-6 col-md-12 col-sm-12 mb-3">
          <select
            className="form-control"
            value={selectedSubService}
            onChange={(e) => setSelectedSubService(e.target.value)}
            disabled={!subServices.length}
            required
          >
            <option value="">Select Sub Service</option>
            {subServices.map((subService, index) => (
              <option value={subService.id} key={index}>
                {subService.community_subservice}
              </option>
            ))}
          </select>
          {errors.subService && (
            <span className="text-danger">{errors.subService}</span>
          )}
        </div>
        <div className="form-group col-lg-6 col-md-12 col-sm-12 mb-3">
          <Select
            options={cityOptions}
            value={cityOptions.find((option) => option.value === selectedCity)}
            onInputChange={throttle((value) => setSearchTerm(value), 300)}
            onChange={(selectedOption) => setSelectedCity(selectedOption.value)}
            placeholder="Select City"
            isSearchable
            required
          />
          {errors.city && <span className="text-danger">{errors.city}</span>}
        </div>

        <div className="form-group col-lg-12 col-md-12 mb-3">
          <textarea
            rows={2}
            name="subject"
            id="subject"
            className="form-control"
            placeholder="Question (Limit 70 characters)"
            // value={formData.subject}
            onChange={handleInputChange}
            required
          ></textarea>
          {errors.subject && (
            <span className="text-danger">{errors.subject}</span>
          )}
        </div>
        <div className="form-group col-lg-12 col-md-12 mb-3">
          <textarea
            rows={3}
            name="question"
            id="question"
            className="form-control"
            placeholder="Description (Limit 500 characters)"
            // value={formData.question}
            onChange={handleInputChange}
            required
          ></textarea>
          {errors.question && (
            <span className="text-danger">{errors.question}</span>
          )}
        </div>

        <input
          className="form-control"
          type="hidden"
          ref={nameRef}
          defaultValue={ProfileuserData?.username || ""}
        />
        <input
          className="form-control"
          type="hidden"
          ref={emailRef}
          defaultValue={ProfileuserData?.email || ""}
        />
        <input
          className="form-control"
          type="hidden"
          ref={numberRef}
          defaultValue={ProfileuserData?.number || ""}
        />

        <div className="form-group col-lg-12 col-md-6 col-sm-12 mb-3">
          <div className="input-group checkboxes square">
            <input
              type="checkbox"
              id="agree"
              name="agree"
              onChange={handleInputChange}
            />
            <label htmlFor="agree" className="remember verifycheckbx">
              <span className="custom-checkbox"></span> I am interested in
              talking to a lawyer for my legal issue
            </label>
          </div>
          {errors.agree && (
            <span className="text-danger d-block">{errors.agree}</span>
          )}
          <p className="agreecondi mt-3">
            By submitting your question, you agree to our{" "}
            <Link to="/term-and-condition">terms & conditions</Link>.
          </p>
        </div>

        <div className="col-lg-12 col-md-12 text-center mb-3">
          <button type="submit" className="theme-btn btn-style-three submitbtn">
            Submit
          </button>
        </div>
      </div>
    </form>
  );
}
